import React from 'react';
import PropTypes from 'prop-types';
import { AlertBase as Alert, Spacer } from '@tfecom-thermofisher/react-komodo-design';

import { Message, Icon } from 'src/core/components';

import './PlateErrorAlert.style.scss';

const PLateErrorAlertComponent = ({ message, ...props }) => (
  <div className="dna-plate-error-alert">
    <Alert
      white
      type="error"
      {...props}
    >
      <Icon name="warning-bold" size={32} color="red" />
      <Spacer right={26} />
      <Message message={message} />
    </Alert>
  </div>
);

PLateErrorAlertComponent.propTypes = {
  message: PropTypes.object,
};

export default PLateErrorAlertComponent;
